/** Shown while data loads. */
export function Loading({ what = 'Loading' }: { what?: string }) {
  return (
    <div className="wrap" aria-busy="true">
      <p className="muted" role="status">{what}…</p>
    </div>
  );
}

/** Shown when loading failed: the plain reason and a way to try again. */
export function LoadError({ error, retry }: { error: Error; retry?: () => void }) {
  return (
    <div className="wrap">
      <div className="card" role="alert">
        <span className="eyebrow">Something went wrong</span>
        <p>{error.message}</p>
        {retry && <div className="row"><button className="btn" onClick={retry}>Try again</button></div>}
      </div>
    </div>
  );
}
